import { red } from "@mui/material/colors";
import React from "react";

export default function DropdownIcon() {
  return (
    <svg className="dropdownIcon" width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg" style={{}}>
      <path d="M1 1L5 5L9 1" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}